import { registerPlugin } from '@capacitor/core';
const CairnPasskeys = registerPlugin('CairnPasskeys', {
    web: () => import('./web').then(m => new m.CairnPasskeysWeb()),
});
export * from './definitions';
export { CairnPasskeys };
